import React, {useMemo} from 'react';
import clsx from 'clsx';
import { Box, Card, Typography } from '@curves/ui-base';

import OverviewListTable from '@Local/Components/OverviewList/OverviewListTable';
import {isEqual, formatCurrencyFn} from '@Util/utils';
import {
    getOrderFeeItemRowLabel,
    getOrderProductItemRowLabel
} from '@Local/Orders/Orders.util';
import {ORDER_ITEM_TYPE_MAP} from '@Constants/appConfig';
/**
 * 訂單商品項目區塊組件
 *
 * 功能：
 * - 顯示訂單相關的商品項目資訊
 * - 根據訂單類型顯示不同的商品清單
 * - 支援商品和費用項目顯示
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Object} props.items - 購買清單
 * @param {Object} props.paymentData - 付款資料
 * @param {Object} props.orderType - 訂單類型
 * @returns {JSX.Element} 商品項目區塊
 */
const OrderItemsSection = ({className, items, paymentData, orderType}) => {
    const headerRow = useMemo(() => {
        if (isEqual(ORDER_ITEM_TYPE_MAP.get(orderType), 'product')) {
            return getOrderProductItemRowLabel();
        } else {
            return getOrderFeeItemRowLabel();
        }
    }, [orderType]);
    return (
        <Card className={clsx("px-3 pt-2 pb-3", className)}>
            <Card.CardContent>
                <Typography variant="body1" className={'mb-2'}>
                    商品清單
                </Typography>
                <Box className="order-items-content">
                    <OverviewListTable headerRow={headerRow} list={items || []} isGray/>
                    <Box className={'text-right px-2 mt-3 mb-1'}>
                        <span className={'font-color-2'}>商品合計：</span>
                        <span className={'font-weight-bold ml-2'}>
                            {formatCurrencyFn(paymentData?.payablePrice || 0, {symbol: '$'})}
                        </span>
                    </Box>
                </Box>
            </Card.CardContent>
        </Card>
    )
};
export default OrderItemsSection;
